// components/OrderDateFilters.jsx

import React from "react";

import {
  FiCalendar,
} from "react-icons/fi";

import {
  DATE_PRESETS,
} from "../utils/orderConstants";


const OrderDateFilters = ({
  filters,

  onPresetChange,

  onDateChange,

  onApplyCustomDate,
}) => {
  const customOpen =
    filters?.datePreset ===
    "custom";

  return (
    <>
      <div
        className="order-date-presets"
      >
        <div
          className="order-date-presets-label"
        >
          <FiCalendar />

          <span>
            View by
          </span>
        </div>


        {DATE_PRESETS.map(
          (
            preset
          ) => {
            const active =
              filters
                ?.datePreset ===
              preset.value;

            return (
              <button
                key={
                  preset.value
                }
                type="button"
                className={
                  active
                    ? "active"
                    : ""
                }
                onClick={() =>
                  onPresetChange?.(
                    preset.value
                  )
                }
              >
                {preset.label}
              </button>
            );
          }
        )}
      </div>


      {customOpen ? (
        <div
          className="order-custom-date-row"
        >
          <div>
            <label>
              From
            </label>

            <input
              type="date"
              value={
                filters
                  ?.dateFrom ||
                ""
              }
              onChange={(
                event
              ) =>
                onDateChange?.(
                  "dateFrom",
                  event.target
                    .value
                )
              }
            />
          </div>


          <div>
            <label>
              To
            </label>

            <input
              type="date"
              value={
                filters
                  ?.dateTo ||
                ""
              }
              onChange={(
                event
              ) =>
                onDateChange?.(
                  "dateTo",
                  event.target
                    .value
                )
              }
            />
          </div>


          <button
            type="button"
            onClick={
              onApplyCustomDate
            }
          >
            Apply Dates
          </button>
        </div>
      ) : null}
    </>
  );
};


export default
  OrderDateFilters;